import request from '@/utils/request'

//秒杀列表
export function getFlashSaleList(data) {
    return request({
        url: '/backend/flashsale/getFlashSaleList',
        method: 'post',
        data: data
    })
}

//创建秒杀商品
export function createFlashSaleProduct(data) {
    return request({
        url: '/backend/flashsale/createFlashSaleProduct',
        method: 'post',
        data: data
    })
}

//创建秒杀排期课
export function createFlashSaleCourseTerm(data) {
    return request({
        url: '/backend/flashsale/createFlashSaleCourseTerm',
        method: 'post',
        data: data
    })
}

//秒杀筛选商品
export function flashSaleProductScreen(data) {
    return request({
        url: '/backend/flashsale/flashSaleProductScreen',
        method: 'post',
        data: data
    })
}

//秒杀信息查看
export function flashSaleInfoShow(data) {
    return request({
        url: '/backend/flashsale/flashSaleInfoShow',
        method: 'post',
        data: data
    })
}

//秒杀信息编辑
export function flashSaleInfoUpdate(data) {
    return request({
        url: '/backend/flashsale/flashSaleInfoUpdate',
        method: 'post',
        data: data
    })
}

//创建秒杀课程
export function createFlashSaleCourse(data) {
    return request({
        url: '/backend/flashsale/createFlashSaleCourse',
        method: 'post',
        data: data
    })
}

//秒杀信息上下架
export function flashSaleInfoSet(data) {
    return request({
        url: '/backend/flashsale/flashSaleInfoSet',
        method: 'post',
        data: data
    })
}

//秒杀信息删除
export function flashSaleInfoDelete(data) {
    return request({
        url: '/backend/flashsale/flashSaleInfoDelete',
        method: 'post',
        data: data
    })
}

//秒杀信息删除
export function flashSaleProductOrder(data) {
    return request({
        url: '/backend/flashsale/flashSaleProductOrder',
        method: 'post',
        data: data
    })
}

//获取绩效详情数据
export function getDetail(data) {
    return request({
        url: '/backend/employee/performance/getDetail',
        method: 'post',
        data: data
    })
}

//暂存草稿或提交绩效
export function saveData(data) {
    return request({
        url: '/backend/employee/performance/saveData',
        method: 'post',
        data: data
    })
}